export default __webpack_public_path__ + "static/media/IconDesc_AluminiumSheet.256.f271f72f.png";